"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = generateUri;

var _convertRouteConstraintsToParameters = _interopRequireDefault(require("../../Router/convertRouteConstraintsToParameters"));

/* istanbul ignore next */
// libraries
function generateUri({
  router,
  id,
  parameters = {},
  scheme,
  userInfo,
  host,
  port,
  query,
  fragment
}) {
  const route = router.findById(id);

  if (!route) {
    throw new Error(`generateUri cannot find route with id ${id}`);
  }

  const matchUri = (0, _convertRouteConstraintsToParameters.default)(route, parameters).getMatchUri();

  if (undefined !== scheme) {
    matchUri.setScheme(scheme);
  }

  if (undefined !== userInfo) {
    matchUri.setUserInfo(userInfo);
  }

  if (undefined !== host) {
    matchUri.setHost(host);
  }

  if (undefined !== port) {
    matchUri.setPort(port);
  }

  if (undefined !== query) {
    matchUri.setQuery(query);
  }

  if (undefined !== fragment) {
    matchUri.setFragment(fragment);
  }

  return matchUri.toString();
}